// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__Nyj9u","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1sNv3","obliqueLine":"membershipbadge_obliqueLine__UXiBl"};